module.exports = __webpack_public_path__ + "static/img/xt.13a343b2.png";